<div class="information-links">
  <a [routerLink]="['/legal']" [queryParams]="{ type: ELegalDocType.Imprint }">
    {{ "common.dictionary.policy.imprint" | translate }}
  </a>
  <a [routerLink]="['/legal']" [queryParams]="{ type: ELegalDocType.DataProtection }">
    {{ "common.dictionary.policy.privacy" | translate }}
  </a>
<a href="https://cdn.ophardt.cloud/v1/pdfs/AGB_B2B_Online_Shop_OPHARDT_2026_V2.pdf" target="_blank" rel="noopener noreferrer">{{ "common.dictionary.policy.terms" | translate }}
  </a>
  <a [routerLink]="['/legal']" [queryParams]="{ type: ELegalDocType.Shipping }">
    {{ "common.dictionary.policy.shipping" | translate }}
  </a>
  <a [routerLink]="['/legal']" [queryParams]="{ type: ELegalDocType.Payment }">
    {{ "common.dictionary.policy.payments" | translate }}
  </a>
  <a [routerLink]="['/legal']" [queryParams]="{ type: ELegalDocType.CancellationAndComplaints }">
    {{ "common.dictionary.policy.cancellation" | translate }}
  </a>
</div>
